import React from "react";
import "./index.scss";
import { motion } from "framer-motion";
import { textBlockVariants } from "../../assets/framer/styles";

const CustomLayout = ({ title, description, children, button, businessTitle }) => {
  return (
    <div className="custom-layout">
      <motion.div
        className="text-block"
        variants={textBlockVariants}
        initial="hidden"
        animate="visible"
      >
        {businessTitle && (
          <h1 className="page-title" style={{fontWeight: 800}}>{businessTitle}</h1>
        )}
        <h1 className="page-title">{title}</h1>
        <p className="page-description">{description}</p>
      </motion.div>
      {children}
      {button}
    </div>
  );
};

export default CustomLayout;
